import React from 'react';
import { useLang } from '../../i18n/LanguageContext';
import { Link } from 'react-router-dom';
import { FaArrowUp, FaTiktok, FaFacebookF, FaLinkedinIn, FaGoogle } from 'react-icons/fa';
import logo from 'assets/images/logo.png';

const LINKS = [
  { key: 'landing.nav.features',     to: '/#features' },
  { key: 'landing.nav.integrations', to: '/#integrations' },
  { key: 'landing.nav.howItWorks',   to: '/#how-it-works' },
  { key: 'landing.footer.testimonials', to: '/#testimonials' },
  { key: 'landing.nav.pricing',      to: '/#pricing' },
];

const PLATFORMS = [
  { icon: <FaTiktok />,    name: 'TikTok' },
  { icon: <FaFacebookF />, name: 'Meta' },
  { icon: <FaLinkedinIn />,name: 'LinkedIn' },
  { icon: <FaGoogle />,    name: 'Google' },
  { icon: <span style={{ fontSize: 14 }}>👻</span>, name: 'Snapchat' },
];

const Footer = () => {
  const { t } = useLang();
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer style={{ background: '#0F0B2D', borderTop: '1px solid rgba(255,255,255,0.06)', padding: '56px 24px 28px' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>

        {/* Top row */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px,1fr))', gap: 40, marginBottom: 48 }}>

          {/* Brand */}
          <div>
            <div style={{ background: '#fff', display: 'inline-flex', borderRadius: 8, padding: '6px 10px', marginBottom: 14 }}>
              <img src={logo} alt="OneBotAds" style={{ height: 28 }} />
            </div>
            <p style={{ fontSize: 13.5, color: 'rgba(255,255,255,0.4)', lineHeight: 1.7, maxWidth: 220 }}>
              {t('landing.footer.tagline')}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 16 }}>{t('landing.footer.colPlatform')}</div>
            {LINKS.map(l => (
              <a key={l.key} href={l.to} style={{ display: 'block', fontSize: 14, color: 'rgba(255,255,255,0.5)', textDecoration: 'none', marginBottom: 10, transition: 'color 0.15s' }}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
              >{t(l.key)}</a>
            ))}
          </div>

          {/* Account */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 16 }}>{t('landing.footer.colAccount')}</div>
            {[{ key: 'landing.footer.login', to: '/login' }, { key: 'landing.footer.signup', to: '/signup' }].map(l => (
              <Link key={l.key} to={l.to} style={{ display: 'block', fontSize: 14, color: 'rgba(255,255,255,0.5)', textDecoration: 'none', marginBottom: 10, transition: 'color 0.15s' }}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
              >{t(l.key)}</Link>
            ))}
          </div>

          {/* Platforms */}
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 16 }}>{t('landing.footer.colSupported')}</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {PLATFORMS.map((p, i) => (
                <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 12px', borderRadius: 8, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)', fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>
                  {p.icon} {p.name}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div style={{ height: 1, background: 'rgba(255,255,255,0.06)', marginBottom: 24 }} />

        {/* Bottom row */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.25)' }}>{t('landing.footer.rights')}</span>
            <Link to="/privacy-policy" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}
              onMouseEnter={e => e.target.style.color = '#fff'} onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>
              {t('landing.footer.privacy')}
            </Link>
            <Link to="/terms-of-service" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}
              onMouseEnter={e => e.target.style.color = '#fff'} onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>
              {t('landing.footer.terms')}
            </Link>
            <Link to="/claude" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}
              onMouseEnter={e => e.target.style.color = '#fff'} onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.4)'}>
              {t('landing.footer.claude')}
            </Link>
          </div>
          <button onClick={scrollToTop} style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(255,255,255,0.07)',
            border: '1px solid rgba(255,255,255,0.12)',
            color: 'rgba(255,255,255,0.6)', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'all 0.2s',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; e.currentTarget.style.color = '#fff'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.07)'; e.currentTarget.style.color = 'rgba(255,255,255,0.6)'; }}
          >
            <FaArrowUp style={{ fontSize: 12 }} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
